<template>
    <div class="report__page">
        <h2>Report Details</h2>
        <ReportDetailsSelector 
            :details="customDetails"
            :is-compact="false"
        />
        <!-- ATTENDANCE LOG -->
    </div>
</template>

<script>
import ReportDetailsSelector from './ReportDetailsSelector.vue';

export default {
    components: {
        ReportDetailsSelector
    },

    data() {
        return {
            customDetails: [
                { value: 'full_name', label: 'Full Name' },
                { value: 'company', label: 'Company' },
                { value: 'site_name', label: 'Site' },
                { value: 'timestamp', label: 'Date / Time' },
                { value: 'checked', label: 'Status' },
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.report__page {
    height: 100%;
    padding: 0.5rem;

    h2 {
        padding-left: 1rem;
        margin: 0;
    }
}
</style>